import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import { CartProvider } from "@/lib/cart";
import Layout from "@/components/Layout";
import Catalog from "@/pages/Catalog";
import BikeDetail from "@/pages/BikeDetail";
import Checkout from "@/pages/Checkout";
import Done from "@/pages/Done";
import Bookings from "@/pages/Bookings";
import Login from "@/pages/Login";
import Profile from "@/pages/Profile";
import RoutesPage from "@/pages/RoutesPage";
import Admin from "@/pages/Admin";
import AdminBikeForm from "@/pages/AdminBikeForm";

const qc = new QueryClient({ defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } } });

export default function App() {
  return (
    <I18nProvider>
      <QueryClientProvider client={qc}>
        <AuthProvider>
          <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Catalog />} />
                <Route path="/bici/:id" element={<BikeDetail />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/confermata" element={<Done />} />
                <Route path="/prenotazioni" element={<Bookings />} />
                <Route path="/percorsi" element={<RoutesPage />} />
                <Route path="/profilo" element={<Profile />} />
                <Route path="/accedi" element={<Login />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/admin/bici/:id" element={<AdminBikeForm />} />
              </Route>
            </Routes>
          </BrowserRouter>
          </CartProvider>
          <Toaster position="top-center" offset={76} richColors />
        </AuthProvider>
      </QueryClientProvider>
    </I18nProvider>
  );
}
